import H1 from '@oneflare/flarekit/lib/components/H1';
import Paragraph from '@oneflare/flarekit/lib/components/Paragraph';
import media from '@oneflare/flarekit/lib/libs/media';
import { styled } from 'styled-components';

export const CategorySectionStyled = styled.section`
  margin: 0 auto;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;

  ${media.mdUp`
    padding: 80px 40px;
  `}

  ${media.xlUp`
    max-width: 1440px;
    padding: 80px 160px;
  `}
`;

export const CategoryHeaderStyled = styled(H1)`
  font-family: ${({ theme }) => theme.font.secondaryBold};
  color: ${({ theme }) => theme.color.charcoal};
  font-size: 28px;
  margin: 0 0 8px;
`;

export const CategorySubTitle = styled(Paragraph)`
  font-size: 18px;
  margin: 0 0 32px;

  ${media.mdUp`
    margin: 0 0 56px;
  `}
`;

export const CategoryContentStyled = styled.div`
  display: flex;
  flex-direction: column;

  ${media.smUp`
    display: grid;
    grid-gap: 56px;
  `}
`;
